import(/* webpackMode: "eager" */ "/app/src/app/(dashboard)/patients/page.tsx");
